import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  DailyRow,
  DeclineDailyRow,
  DeclineReasonRow,
  DeclineRegionRow,
  KeyMetrics,
  ProductRow,
  RegionRow,
  SalesReportData,
} from 'src/app/features/dashboard/sales-report/sales-report-dashboard.model';

@Injectable({ providedIn: 'root' })
export class SalesReportService {
  private readonly base = `${environment.apiUrl}/loan/api/sales-report`;

  constructor(private http: HttpClient) {}

  /** Single call returning the full bundled report. Prefer this for the dashboard. */
  getFullReport(reportDate: string): Observable<SalesReportData> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<SalesReportData>(`${this.base}/full`, { params, observe: 'response' }).pipe(
      tap(resp => console.log('API response headers:', resp.headers)),
      tap(resp => console.log('API response body:', resp.body)),
      map(resp => resp.body as SalesReportData)
    )
    ;
  }

  getSummary(reportDate: string): Observable<KeyMetrics> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<KeyMetrics>(`${this.base}/summary`, { params });
  }

  getDailyProgression(reportDate: string): Observable<DailyRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<DailyRow[]>(`${this.base}/daily-progression`, { params });
  }

  getByRegion(reportDate: string): Observable<RegionRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<RegionRow[]>(`${this.base}/by-region`, { params });
  }

  getByProduct(reportDate: string): Observable<ProductRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<ProductRow[]>(`${this.base}/by-product`, { params });
  }

  getDeclineReasons(reportDate: string): Observable<DeclineReasonRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<DeclineReasonRow[]>(`${this.base}/decline-reasons`, { params });
  }

  getDeclineDailyTrend(reportDate: string): Observable<DeclineDailyRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<DeclineDailyRow[]>(`${this.base}/decline-daily-trend`, { params });
  }

  getDeclineByRegion(reportDate: string): Observable<DeclineRegionRow[]> {
    const params = new HttpParams().set('reportDate', reportDate);
    return this.http.get<DeclineRegionRow[]>(`${this.base}/decline-by-region`, { params });
  }
}
